import { Link, useLocation } from 'react-router-dom'
import config from '../../config'

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation()
  
  // Extract section from pathname
  const getSection = () => {
    const path = location.pathname
    const match = path.match(/\/admin\/([^/?]+)/)
    return match ? match[1] : 'dashboard'
  }
  
  const section = getSection()

  const isActive = (sectionName) => {
    return section === sectionName ? 'active' : ''
  }

  // Close drawer when a link is clicked
  const handleLinkClick = () => {
    onClose()
  }

  return (
    <>
      <div 
        className={`admin-backdrop ${isOpen ? 'active' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      ></div>
      
      <aside 
        className={`admin-sidebar ${isOpen ? 'open' : ''}`}
        aria-label="Admin navigation"
      >
        <button
          type="button"
          className="admin-drawer-close"
          onClick={onClose}
          aria-label="Close menu"
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        
        <nav>
          <div className="section-label">Manage</div>
          <ul>
            <li className={isActive('dashboard')}>
              <Link to="/admin/dashboard" onClick={handleLinkClick}>
                <i className="fa fa-tachometer"></i> Dashboard
              </Link>
            </li>
            <li className={isActive('carousel')}>
              <Link to="/admin/carousel" onClick={handleLinkClick}>
                <i className="fa fa-picture-o"></i> Homepage Hero / Carousel
              </Link>
            </li>
            <li className={isActive('nav')}>
              <Link to="/admin/nav" onClick={handleLinkClick}>
                <i className="fa fa-bars"></i> Navbar &amp; Pages
              </Link>
            </li>
            <li className={isActive('about')}>
              <Link to="/admin/about" onClick={handleLinkClick}>
                <i className="fa fa-users"></i> About Us
              </Link>
            </li>
            <li className={isActive('services')}>
              <Link to="/admin/services" onClick={handleLinkClick}>
                <i className="fa fa-th-large"></i> Services &amp; Categories
              </Link>
            </li>
            <li className={isActive('all-services')}>
              <Link to="/admin/all-services" onClick={handleLinkClick}>
                <i className="fa fa-files-o"></i> All Services
              </Link>
            </li>
            <li className={isActive('blog')}>
              <Link to="/admin/blog" onClick={handleLinkClick}>
                <i className="fa fa-pencil"></i> Blog Posts
              </Link>
            </li>
            <li className={isActive('gallery')}>
              <Link to="/admin/gallery" onClick={handleLinkClick}>
                <i className="fa fa-image"></i> Gallery
              </Link>
            </li>
            <li className={isActive('testimonials')}>
              <Link to="/admin/testimonials" onClick={handleLinkClick}>
                <i className="fa fa-quote-left"></i> Reviews
              </Link>
            </li>
          </ul>
          
          <div className="section-label">Marketing</div>
          <ul>
            <li className={isActive('offers')}>
              <Link to="/admin/offers" onClick={handleLinkClick}>
                <i className="fa fa-tag"></i> Offers
              </Link>
            </li>
          </ul>
          
          <div className="section-label">Inbox</div>
          <ul>
            <li className={isActive('appointments')}>
              <Link to="/admin/appointments" onClick={handleLinkClick}>
                <i className="fa fa-calendar-check-o"></i> Appointments
              </Link>
            </li>
            <li className={isActive('contacts')}>
              <Link to="/admin/contacts" onClick={handleLinkClick}>
                <i className="fa fa-envelope-o"></i> Messages
              </Link>
            </li>
          </ul>
          
          <div className="section-label">System</div>
          <ul>
            <li className={isActive('settings')}>
              <Link to="/admin/settings" onClick={handleLinkClick}>
                <i className="fa fa-cog"></i> Website Content
              </Link>
            </li>
            <li className={isActive('account')}>
              <Link to="/admin/account" onClick={handleLinkClick}>
                <i className="fa fa-user-circle-o"></i> Admin Account
              </Link>
            </li>
          </ul>
        </nav>
        
        <a 
          href={config.web.baseUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="admin-view-site"
        >
          <i className="fa fa-external-link"></i> View Website
        </a>
      </aside>
    </>
  )
}

export default Sidebar
